import { render, staticRenderFns } from "./CarouselSection.vue?vue&type=template&id=5696cc0a"
import script from "./CarouselSection.vue?vue&type=script&lang=js"
export * from "./CarouselSection.vue?vue&type=script&lang=js"
import style0 from "./CarouselSection.vue?vue&type=style&index=0&id=5696cc0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports